import { useCallback, useState } from 'react';
import { GroupContextMenu } from '../Menu/GroupContextMenu';
import type { AddNewNodeOptions } from '../flowTypes';

interface GroupContextMenuState {
  x: number | null;
  y: number | null;
  isOpen: boolean;
  groupNodeId: string | null;
}

interface UseGroupContextMenuProps {
  addNewNode: ({ action, dropX, dropY, connection }: AddNewNodeOptions) => void;
}

export const useGroupContextMenu = ({ addNewNode }: UseGroupContextMenuProps) => {
  const [groupContextMenu, setGroupContextMenu] = useState<GroupContextMenuState>({
    x: null,
    y: null,
    isOpen: false,
    groupNodeId: null,
  });

  const openGroupContextMenu = useCallback((x: number, y: number, groupNodeId: string) => {
    setGroupContextMenu({
      x: x,
      y: y,
      isOpen: true,
      groupNodeId,
    });
  }, []);

  const closeGroupContextMenu = useCallback(() => {
    setGroupContextMenu((current) => ({ ...current, isOpen: false }));
  }, []);

  const groupContextMenuComponent =
    groupContextMenu.isOpen &&
    groupContextMenu.x !== null &&
    groupContextMenu.y !== null &&
    groupContextMenu.groupNodeId ? (
      <GroupContextMenu
        key="group-context-menu"
        positionX={groupContextMenu.x}
        positionY={groupContextMenu.y}
        isOpen={groupContextMenu.isOpen}
        onClose={closeGroupContextMenu}
        groupNodeId={groupContextMenu.groupNodeId}
        addNewNode={addNewNode}
      />
    ) : null;

  return {
    openGroupContextMenu,
    closeGroupContextMenu,
    groupContextMenuComponent,
  };
};
